import { useLoaderData, useLocation, useNavigate } from "react-router";
import { IApiService, UserDetail } from "../../services/ApiService";
import { useState } from "react";
import { Alert, Button, Stack, TextField } from "@mui/material";
import { LogosHeader } from "../../components/LogosHeader";

export interface MePageProps {
    readonly apiService: IApiService;
}

export const MePage = (props: MePageProps) => {
    const { apiService } = props;
    const data = useLoaderData() as { userDetail: UserDetail };
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const returnUrl = query.get("returnUrl");

    return <Stack sx={{p: 2, pt: 4}} spacing={2}>
        <LogosHeader sx={{mb: 4}} />
        <Stack spacing={2}>
            <MeForm returnUrl={returnUrl} apiService={apiService} userDetail={data.userDetail} />
        </Stack>
    </Stack>;
}

interface MeFormProps {
    readonly apiService: IApiService;
    readonly returnUrl: string | null;
    readonly userDetail: UserDetail;
}

const MeForm = (props: MeFormProps) => {
    const { apiService, returnUrl, userDetail } = props;
    const [firstName, setFirstName] = useState(userDetail.firstName || "");
    const [lastName, setLastName] = useState(userDetail.lastName || "");
    const [inProgress, setInProgress] = useState<boolean>(false);
    const [networkError, setNetworkError] = useState<string | undefined>(undefined);
    const formEnabled = firstName.trim() && lastName.trim() && !inProgress;
    const navigate = useNavigate();
    const handleClick = async() => {
        if (!formEnabled) {
            return;
        }
        if (!firstName?.trim() || !lastName?.trim()) {
            throw new Error("Unexpected");
        }
        setNetworkError(undefined);
        setInProgress(true);
        const abortController = new AbortController();
        try {
            await apiService.setUserDetail({
                firstName: firstName.trim(),
                lastName: lastName.trim()
            }, abortController.signal);
            navigate(returnUrl ?? "/", {
                replace: true
            });
        } catch (e) {
            setNetworkError("Impossible d'enregistrer. Vérifiez votre connexion.");
        } finally {
            setInProgress(false);
        }
    };
    return <>
        {networkError && <Alert severity="error">{networkError}</Alert>}
        {returnUrl && <Alert severity="warning">
            L'usage de l'application nécessite que vous précisiez vos nom et prénom.
        </Alert>}
        <TextField
            inputProps={{ readOnly: true }}
            margin="normal"
            value={userDetail.email}
            required
            fullWidth
            label="Adresse email"
        />
        <TextField
            margin="normal"
            value={firstName}
            onChange={(ev) => setFirstName(ev.currentTarget.value)}
            required
            fullWidth
            label="Prénom"
        />
        <TextField
            margin="normal"
            value={lastName}
            onChange={(ev) => setLastName(ev.currentTarget.value)}
            required
            fullWidth
            label="Nom"
        />
        <Button
            onClick={() => handleClick()}
            disabled={inProgress}
            type="submit"
            fullWidth
            variant="contained">
            Enregistrer
        </Button>
    </>;
}
